import React from 'react';
import { Clock, User } from 'lucide-react';
import { FracasIncident } from '../../types/fracas.types';

export const FracasSidebar: React.FC<{ incident: FracasIncident }> = ({ incident }) => {
    return (
        <div className="space-y-6">
            {/* Timeline */}
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
                    <Clock className="w-5 h-5" />
                    Timeline
                </h3>
                <div className="space-y-4">
                    <div className="flex items-start gap-3">
                        <div className="w-2 h-2 bg-blue-600 rounded-full mt-2"></div>
                        <div className="flex-1">
                            <p className="text-sm font-medium text-gray-900">Reported</p>
                            <p className="text-sm text-gray-600">
                                {new Date(incident.reportedAt).toLocaleDateString()}
                            </p>
                        </div>
                    </div>
                    {incident.statusHistory?.map((hist, idx) => (
                        <div key={idx} className="flex items-start gap-3">
                            <div className={`w-2 h-2 rounded-full mt-2 ${hist.status === 'Closed' ? 'bg-gray-600' : 'bg-purple-600'}`}></div>
                            <div className="flex-1">
                                <p className="text-sm font-medium text-gray-900">{hist.status}</p>
                                <p className="text-xs text-gray-500">{new Date(hist.changedAt).toLocaleDateString()}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Assignment Info */}
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                <h3 className="text-lg font-bold text-gray-900 mb-4">Assignment</h3>
                <div className="space-y-3">
                    <div>
                        <p className="text-sm text-gray-600">Reported By</p>
                        <p className="text-gray-900 font-medium flex items-center gap-2">
                            <User className="w-4 h-4" />
                            {incident.reportedByName}
                        </p>
                    </div>
                    {incident.assignedToName && (
                        <div>
                            <p className="text-sm text-gray-600">Assigned To</p>
                            <p className="text-gray-900 font-medium flex items-center gap-2">
                                <User className="w-4 h-4" />
                                {incident.assignedToName}
                            </p>
                        </div>
                    )}
                </div>
            </div>

            {/* Tags */}
            {incident.tags && incident.tags.length > 0 && (
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                    <h3 className="text-lg font-bold text-gray-900 mb-3">Tags</h3>
                    <div className="flex flex-wrap gap-2">
                        {incident.tags.map((tag, index) => (
                            <span
                                key={index}
                                className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm font-medium"
                            >
                                {tag}
                            </span>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};
